import { SelectBoxArrowDown } from '@icons/SelectBoxArrowDown';
import { SelectBoxArrowUp } from '@icons/SelectBoxArrowUp';
import { type ReactNode, useState } from 'react';
import type { FieldType, Option } from '../../../types/EvalancheTypes';
import {
  Container,
  ErrorMessage,
  FormLabel,
  Input,
  MainLabel,
  OptionLabel,
  OptionWrapper,
  OptionsBox,
} from '../styles';

export const SelectInput = ({
  field,
  formikProps,
}: {
  field: FieldType;
  formikProps: any;
}): ReactNode => {
  const options = Array.isArray(field.options) ? field.options : Object.values(field.options || {});
  const defaultOption = field.default_value
    ? options?.find((option) => option.key.toString() === field.default_value)
    : options?.[0];
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [showOptions, setShowOptions] = useState<boolean>(false);

  const selectOption = (event: any, selected: Option) => {
    event.preventDefault();
    setSelectedOption(selected);
    setShowOptions(false);
    // eslint-disable-next-line no-param-reassign
    formikProps.values[field?.name] = selected?.key.toString();
  };

  const showOptionsData = () => setShowOptions(!showOptions);

  return (
    <Container className={field.hidden ? 'hidden' : ''}>
      <MainLabel>
        <FormLabel tag="label" type="lead" className="text-gray-500">
          {field.label}
        </FormLabel>
        <Input
          type="text"
          value={selectedOption?.value}
          onClick={showOptionsData}
          onChange={formikProps.handleChange}
        />
        <div className="absolute right-5 bottom-5">
          {showOptions ? <SelectBoxArrowUp /> : <SelectBoxArrowDown />}
        </div>
      </MainLabel>
      <OptionsBox className={showOptions ? '' : 'hidden'}>
        {options?.map((option: Option) => (
          <OptionWrapper
            className={`border-b border-grayBorder m-0${
              option.key === selectedOption?.key ? ' selected' : ''
            }`}
            key={option.key}
          >
            <OptionLabel onClick={(e) => selectOption(e, option)}>
              <input
                type="radio"
                defaultValue={option?.value}
                className="hidden"
                onChange={() => formikProps.setFieldValue(option.key)}
                checked={formikProps.values[option.key]}
              />
              {option.value}
            </OptionLabel>
          </OptionWrapper>
        ))}
      </OptionsBox>

      {formikProps.errors[field.name] && (
        <ErrorMessage data-test={`select-${field.name}-error`}>
          {formikProps.errors[field.name]}
        </ErrorMessage>
      )}
    </Container>
  );
};
